import { Metamodel } from 'shell-models-lib';
import { DatasetFormatType } from './dataflow-dataset-settings';
import { SqlBaseSettings } from './sql-base-settings';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.azureSql.dataflowSettings,
    validator: SqlDBSettings.validateSettings
})
export class SqlDBSettings extends SqlBaseSettings {
    public getFormat(): DatasetFormatType {
        return DatasetFormatType.SqlDB;
    }

    public getIconClass(): string {
        return 'i-100x100-AzureSQLDatabase';
    }

    public initialize(subFormat: string): void {
        super.initialize(subFormat);
        this.store = DatasetFormatType.SqlDB;
    }
}
